export default __webpack_public_path__ + "static/1-96386c438788f752b9909dd8322462d1.png";